<template>
  <div class="event" style="width:100%">
    <p>{{ $store.getters['getClientMeta'].name }}</p>
    <h3 class="line-title">Üyelik Doğrulama</h3>
    <div class="mobile-nav-menu" v-if="isMobile">
      <ul>
          <li><a @click="activeMenu = 'phone'" :class="activeMenu == 'phone' ? 'active' : ''" href="javascript:;">Telefon</a></li>
          <li><a @click="activeMenu = 'g2fa'" :class="activeMenu == 'g2fa' ? 'active' : ''" href="javascript:;">G2FA Doğrulama</a></li>
          <li><a @click="activeMenu = 'mail'" :class="activeMenu == 'mail' ? 'active' : ''" href="javascript:;">E-Mail Doğrulama</a></li>
      </ul>
    </div>
    <div class="alert alert-danger" v-if="!isVerifyPhone" style="font-size:12px"> 
        <b>Telefon numaranızı</b> doğrulayınız.
    </div>
    <div class="alert alert-danger" v-if="!isVerifyMail" style="font-size:12px"> 
        <b>E-Mail Adresinizi</b> doğrulayınız.
    </div>
    <div class="user-content-inc">
      <div class="row row-wrap">
        <div class="col col-12" v-if="activeMenu == 'phone' || !isMobile">
            <div class="security validation">
                <h3>{{ phoneStep == 1 ? 'SMS DOĞRULAMA' : 'SMS KODU' }}</h3>
                <form class="content direction-column" @submit.prevent="phoneSend" v-if="phoneStep == 1">
                    <div class="col col-12 info">
                        <div class="row">
                          <div class="col col-12">
                            <h5>Telefon Numarası
                              <b class="status-label status_2" v-if="isVerifyPhone">Doğrulandı</b>
                              <b class="status-label status_3" v-else>Doğrulanmadı</b>
                            </h5>
                            <small>Şuanki : {{ userDetail.detail.phone }}</small>
                          </div>
                        </div>
                    </div>
                    <br>
                      <div class="col col-12">
                        <vue-tel-input @input="onTelInput" v-bind="telProps"></vue-tel-input>
                      </div>
                      <br>
                      <div class="col col-12">
                          <ButtonLoader class="primary" :loader="isPhoneLoading" :text="'Kodu Gönder'" >
                            <template name="icon">
                              <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                            </template>
                          </ButtonLoader>
                      </div>
                </form>
                <form class="content direction-column" @submit.prevent="codeSend" v-if="phoneStep == 2">
                    <div class="col col-12 info">
                        <div class="row">
                          <div class="col col-12">
                            <h5>Telefon Numarası
                              <b class="status-label status_2" v-if="isVerifyPhone">Doğrulandı</b>
                              <b class="status-label status_3" v-else>Doğrulanmadı</b>
                            </h5>
                            <small>Kalan Süre : {{ timerCount }}</small>
                          </div>
                        </div>
                    </div>
                    <br>
                      <div class="col col-12">
                          <input maxlength = "6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" :type="!isMobile ? 'number' : 'tel'" v-model="phoneCode" placeholder="Telefonunuza gönderilen kodu yazınız">
                      </div>
                      <br>
                      <div class="col col-12">
                          <ButtonLoader class="primary" :loader="isPhoneLoading" :text="'Doğrulamayı Tamamla'" >
                            <template name="icon">
                              <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                            </template>
                          </ButtonLoader>
                      </div>
                </form>
            </div>
        </div>
        <div class="col col-6" v-if="activeMenu == 'g2fa' || !isMobile">
            <div class="security g2fa direction-column" v-if="!user.is_g2fa">
                <h3>G2FA DOĞRULAMA</h3>
                <form class="content" @submit.prevent="g2faSend">
                    <div class="barcode">
                      <img :src="'data:image/png;base64,' + g2fa.qr">
                    </div>
                    <div class="form-inc">
                        <h6>İki Aşamalı Doğrulama</h6>
                        <small>Güvenlik: {{ g2fa.code }}</small>
                        <div class="inputs">
                            <div class="col col-12">
                              <input placeholder="Kod" type="number" v-model="g2faCode">
                            </div>
                            <br>
                            <div class="col col-12">
                              <ButtonLoader class="primary" :loader="isG2faLoading" :text="'Aktif Et'" >
                                <template name="icon">
                                  <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                                </template>
                              </ButtonLoader>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="security g2fa direction-column" v-if="user.is_g2fa">
              <h3>G2FA DOĞRULAMA</h3>
              <div class="content">
                <div class="alert flex align-center justify-center" style="width:250px;">
                  <svg style="width:15px;15px;margin-right:10px" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                  İki Aşamalı Doğrulama Aktif
                </div>
              </div>
            </div>
        </div>
        <div class="col col-6" v-show="activeMenu == 'mail' || !isMobile">
          <div class="security validation">
            <h3>E-MAIL DOĞRULAMA</h3>
            <form class="content direction-column" @submit.prevent="mailSend">
                <div class="col col-12 info">
                    <div class="row">
                      <div class="col col-12">
                        <h5>E-Posta Adresi 
                          <b class="status-label status_2" v-if="isVerifyMail">Doğrulandı</b>
                          <b class="status-label status_3" v-else>Doğrulanmadı</b>
                        </h5>
                        <small>{{ hideMail }}</small>
                      </div>
                    </div>
                </div>
                <br>
                  <div class="col col-12">
                      <input type="email" placeholder="E-Mail" v-model="newMail">
                      
                  </div>
                  <br>
                  <div class="col col-12">
                      <ButtonLoader class="primary" :loader="isMailLoading" :text="'Linki Gönder'" >
                        <template name="icon">
                          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                      </ButtonLoader>
                  </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import { VueTelInput } from 'vue-tel-input'
  export default{
    data(){
      return{
        g2faCode: null,
        newPhone: null,
        newPhoneCountry: null,
        phoneCode: null,
        phoneStep: 1,
        timerCount: 180,
        newMail: null,
        telProps:{
          placeholder: "Telefon numaranızı yazınız",
          enabledFlags: true,
        },
        telProps:{
          defaultCountry: this.$i18n.locale,
          placeholder: "Telefon numaranızı yazınız",
          enabledFlags: true
        },
        activeMenu: 'phone',
        g2fa:{
          code: null,
          qr: null,
        },
        isG2faLoading:false,
        isMailLoading:false,
        isPhoneLoading:false,
      }
    },
    components: {
      VueTelInput,
    },
    computed:{
      ...mapState("countries", ["countries"]),
      user(){
        return this.$user();
      },
      hideMail(){
        return this.user.email.replace(/(.{2})(.*)(?=@)/,
        function(gp1, gp2, gp3) { 
          for(let i = 0; i < gp3.length; i++) { 
            gp2+= "*"; 
          } return gp2; 
        });
      },
      userDetail(){
          return this.$user_detail();
      },
      isVerifyMail(){
        return !_.isUndefined(this.userDetail.detail.validations.email) && this.userDetail.detail.validations.email.r == 1 && this.userDetail.detail.validations.email.s == 1;
      },
      isVerifyPhone(){
        return !_.isUndefined(this.userDetail.detail.validations.phone) && this.userDetail.detail.validations.phone.r == 1 && this.userDetail.detail.validations.phone.s == 1;
      }
    },
    created(){
      if(!this.user.is_g2fa){
        this.fetchG2fa();
      }
    },
    methods:{
      onTelInput(formattedNumber, { number, country }) {
        this.newPhoneCountry = '+' + country.dialCode;
        this.newPhone = number.significant;
      },
      fetchG2fa() {
        axios.get('/auth/g2fa')
          .then((response)=>{
            this.g2fa.code = response.data.data.code;
            this.g2fa.qr = response.data.data.qr;
          })
          .catch((err)=>{
              
          })
      },
      runTimer(){
        if (this.timerCount > 0) {
            setTimeout(() => {
                this.timerCount--;
                this.runTimer();
            }, 1000);
        }else{
          this.phoneStep = 1
        }
        
      },
      phone(){
        alert(this.newPhone);
      },
      g2faSend(){
        this.isG2faLoading = true;
        axios.patch('/auth/g2fa', { code : this.g2faCode })
          .then((response)=>{
              if(response.data.status){
                this.$store.dispatch('auth/token', response.data.data.token);
                this.$store.dispatch('auth/user');
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.isG2faLoading = false;
          })
      },
      phoneSend(){
        this.isPhoneLoading = true;
        axios.post('/auth/phone/verify', { phone : this.newPhone, code : this.newPhoneCountry })
          .then((response)=>{
              if(response.data.status){
                this.phoneStep = 2
                this.runTimer();
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.isPhoneLoading = false;
          })
      },
      codeSend(){
        this.isPhoneLoading = true;
        axios.patch('/auth/phone/verify', { code : this.phoneCode })
          .then((response)=>{
              if(response.data.status){
                this.phoneStep = 1
                //this.$store.dispatch('auth/token', response.data.data.token);
                this.$store.dispatch('auth/userInit');
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.isPhoneLoading = false;
          })
      },
      mailSend(){
        this.isMailLoading = true;
        axios.post('/auth/email/verify', { email : this.newMail })
          .then((response)=>{
              if(response.data.status){
                //this.$store.dispatch('auth/token', response.data.data.token);
                this.$store.dispatch('auth/userInit');
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.isMailLoading = false;
          })
      }
    }
  }
</script>